<ng-container *transloco="let t; read: 'ime.manufacturing.publish-drafts'">
  <app-toolbar>
    <app-breadcrumbs></app-breadcrumbs>
    <app-page-search #search class="me-auto" (searchStringChange)="search$.next($event)"></app-page-search>
    <div class="btn-toolbar btn-max-content flex-nowrap justify-content-end">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="publishSelection()">
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#table-cells'">
        </svg>
        {{t('Publish')}}
      </button>
    </div>
  </app-toolbar>
  <form class="filter-horizontal bg-white ng-pristine ng-valid mb-1" *ngIf="search.showFilters">
    <div class="col-md-3">
      <label>{{t('Modified by')}}</label>
      <mes-user-select [entityId]="modifiedBy" [items$]="usersQuery.getAll$" name="salesManager" [allowAdd]="false" [allowEdit]="false" (entityIdChange)="modifiedBy = $event; getDraftsToFinal()"></mes-user-select>
    </div>
  </form>
  <p-table styleClass="p-datatable-sm pb-2"
           dataKey="FinalId"
           [value]="drafts$ | async"
           [(selection)]="selectedGroups"
           [lazy]="true"
           [lazyLoadOnInit]="false"
           [expandedRowKeys]="expandedKeys"
           [showCurrentPageReport]="true">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th style="width: 3rem">
        </th>
        <th>
          {{t('Draft')}}
        </th>
        <th class="wx-128">
          {{t('Modified by')}}
        </th>
        <th>
          {{t('Final')}}
        </th>
        <th class="wx-128">
          {{t('Modified by')}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-line let-expanded="expanded" let-rowIndex="rowIndex">
      <tr *ngLet="getRow(line) as row">
        <td>
          <p-tableCheckbox #tableCheckbox [value]="row" [index]="rowIndex" (click)="changeSelection(tableCheckbox, $event)"></p-tableCheckbox>
        </td>
        <td>
          <a href="javascript:void(0)" class="badge bg-secondary text-decoration-none" title="Expand/Collapse Row" [pRowToggler]="row">
            {{row.Connections.length}}
            <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="expanded ? '#chevron-down' : '#chevron-right'"></svg>
          </a>
        </td>
        <td class="text-wrap text-break" [title]="row.DraftId ?? ''">
          <a href="javascript:void(0)" (click)="openItemGroup(row.DraftId)">{{itemGroupsQuery.selectEntity(row.DraftId) | async | displayName}}</a>
        </td>
        <td>
          {{(usersQuery.selectEntity(row.DraftModifiedBy) | async)?.DisplayName}}
        </td>
        <td class="text-wrap text-break" [title]="row.FinalId">
          <a href="javascript:void(0)" (click)="openItemGroup(row.FinalId)">{{itemGroupsQuery.selectEntity(row.FinalId) | async | displayName}}</a>
        </td>
        <td>
          {{(usersQuery.selectEntity(row.FinalModifiedBy) | async)?.DisplayName}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-line>
      <ng-container *ngIf="getRow(line) as row">
        <tr class="table-secondary" *ngFor="let item of row.Connections">
          <td></td>
          <td></td>
          <td class="text-wrap text-break" [title]="item.DraftId">
            <a href="javascript:void(0)" (click)="openItem(item.DraftId)">{{itemsQuery.selectEntity(item.DraftId) | async | displayName}}</a>
          </td>
          <td></td>
          <td class="text-wrap text-break" [title]="item.FinalId">
            <a href="javascript:void(0)" (click)="openItem(item.FinalId)">{{itemsQuery.selectEntity(item.FinalId) | async | displayName}}</a>
          </td>
          <td></td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</ng-container>
